import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { of, Observable } from 'rxjs';
import { catchError, mapTo, tap, map } from 'rxjs/operators';
// import * as moment from 'moment';
// import * as moment_tz from 'node_modules/moment-timezone';

import axios from "axios";


@Injectable({ providedIn: 'root' })
export class EventService {
    private defaultUrl: any;
    private defaultUrlControl: any;
    constructor(private http: HttpClient) {

        this.defaultUrl = axios.create({
            baseURL: environment.API
        });

        this.defaultUrlControl = axios.create({
            baseURL: environment.API_CONTROL
        });
    }


    public testAPI(): Observable<any> {

        return this.http.get<any>(`${environment.API}${environment.URL_GET_DETAIL_PLOT_BY_ID}/12313213`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getEventList(id): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_EVENT_BY_CROP_ID}/?crop_id=${id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getActivityType(): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_EVENT_ACTIVITY_TYPE}`, {
            "dom_id": "event",
            "sub_dom_id": "activityType"
        })
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getWorkingType(): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_EVENT_WORKING_TYPE}`, {
            "dom_id": "event",
            "sub_dom_id": "workingType"
        })
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getResponsiblePerson(): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_EVENT_RESPONSIBLE_PERSON}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    
    public getStatus(): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_EVENT_STATUS}`, {
            "dom_id": "event",
            "sub_dom_id": "status"
        })
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    
    public getDisease(): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_EVENT_DISEASE}`, {
            "dom_id": "event",
            "sub_dom_id": "disease"
        })
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    
    public getAvailablePoles(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_EVENT_AVAILABLE_POLE}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getAvailableValves(id): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_EVENT_AVAILABLE_VALVES}/?plot_id=${id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public addEvent(data){
        return this.http.post<any>(`${environment.API}${environment.URL_ADD_EVENT}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getEventById(id): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_EVENT_BY_ID}/?id=${id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public deleteEvent(id): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_DELETE_EVENT_BY_ID}`, {"id" : id})
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public editEvent(data){
        return this.http.post<any>(`${environment.API}${environment.URL_EDIT_EVENT}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
}